import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './api.utils';
import { MitarbeiterRole } from './types';

export interface LoginResponseSuccess {
  user_id: string;
  access_token: string;
  refresh_token: string;
  role: MitarbeiterRole;
  requiresTwoFactor?: false;
}

export interface LoginResponseMfaChallenge {
  requiresTwoFactor: true;
  userId: string;
  tmpToken: string;
}

export type LoginResponse = LoginResponseSuccess | LoginResponseMfaChallenge;

export interface LoginRequest {
  username: string;
  password: string;
}

export interface ActionSuccessResponse {
  success: boolean;
}

export interface Generate2faResponse {
  setupString: string;
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: credentials => ({
        url: 'auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    generate2fa: builder.mutation<Generate2faResponse, void>({
      query: () => ({
        url: 'auth/2fa/generate',
        method: 'POST',
      }),
    }),
    enable2fa: builder.mutation<ActionSuccessResponse, { code: string }>({
      query: ({ code }) => ({
        url: 'auth/2fa/enable',
        method: 'POST',
        body: { code },
      }),
    }),
    verifyLogin2fa: builder.mutation<LoginResponseSuccess, { code: string; tmpToken: string }>({
      query: ({ code, tmpToken }) => ({
        url: 'auth/2fa/verify-login',
        method: 'POST',
        headers: { Authorization: `Bearer ${tmpToken}` },
        body: { code },
      }),
    }),
    disable2fa: builder.mutation<ActionSuccessResponse, { code: string }>({
      query: ({ code }) => ({
        url: 'auth/2fa/disable',
        method: 'POST',
        body: { code },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGenerate2faMutation,
  useEnable2faMutation,
  useVerifyLogin2faMutation,
  useDisable2faMutation,
} = authApi;
